import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { required } from '../../../../utils/validate';

import './veridQuestion.scss';

const VeridQuestion = ({ question }) => (
  <fieldset id={question.id} className="verid-question container">
    <div className="row justify-content-center">
      <div className="col col-xl-8">
        <h2>{question.text}</h2>
        <p className="subtext">{question.helpText}</p>
        <ul>
          { question.choices.map(choice => (
            <li key={choice.choiceId}>
              <label htmlFor={choice.choiceId}>
                <Field
                  component="input"
                  type="radio"
                  name={`question-${question.id}`}
                  value={choice.choiceId}
                  id={choice.choiceId}
                  validate={[required]}
                  required={true}
                />
                {` ${choice.text}`}
              </label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </fieldset>
);

VeridQuestion.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string,
    helpText: PropTypes.string,
    choices: PropTypes.arrayOf(PropTypes.shape({
      choiceId: PropTypes.string,
      text: PropTypes.string
    }))
  }).isRequired
};

export default VeridQuestion;
